<template>
  <v-card :class="classSection" :height="cardHeight">
    <v-card-title>
      <!-- <v-icon large left>mdi-twitter</v-icon> -->
      <v-avatar :class="classAvatar" size="56">
        <img src="@/assets/client.svg" />
      </v-avatar>
      <span class="title font-weight-light">Client</span>
      <v-spacer></v-spacer>
      <ActionFabButton mode="edit" :cb="() => showDialog()" />
    </v-card-title>
    <div class="section-line"></div>
    <v-list-item class="mt-n7">
      <v-list-item-content>
        <v-row v-if="hasClient">
          <!-- <span class="body-2 font-weight-light ml-3">There is a client: {{ clientName }}</span> -->
          <v-col cols="7">
            <v-list-item-subtitle
              class="title font-regular font-weight-light text--primary"
              v-text="clientName"
            ></v-list-item-subtitle>
            <v-list-item-subtitle class="body-2 font-weight-bold mt-3" v-text="client.addressLine1"></v-list-item-subtitle>
            <v-list-item-subtitle class="body-2 mt-2" v-text="client.city"></v-list-item-subtitle>
            <v-list-item-title class="mt-1">
              <span class="body-2 font-weight-light">{{ client.postcode }}</span>
              <span class="body-2 font-weight-light ml-4">{{ client.county }}</span>
            </v-list-item-title>
          </v-col>
          <v-col cols="5">
            <div class="mt-9">
              <v-icon small class="grey--text mb-1">mdi-phone</v-icon>
              <span class="body-2 ml-1 mt-1">{{ client.telHome || "[no number]" }}</span>
            </div>
            <div class="mt-2">
              <v-icon small class="grey--text mb-1">mdi-cellphone-iphone</v-icon>
              <span class="body-2 ml-1 mt-1">{{ client.telMobile || "[no number]" }}</span>
            </div>
          </v-col>
        </v-row>
        <v-row v-else>
          <!-- <v-list-item-subtitle class="ml-10 text--primary">No Client</v-list-item-subtitle> -->
          <span class="body-2 font-weight-light ml-3">No Client</span>
        </v-row>
      </v-list-item-content>
    </v-list-item>

    <v-row justify="center">
      <v-dialog v-model="showingDialog" scrollable max-width="350px">
        <DialogClientListSelect :obj="obj" />
      </v-dialog>
    </v-row>
  </v-card>
</template>

<script>
import { ref, computed } from "@vue/composition-api";
import ActionFabButton from "@/components/ActionFabButton";
import { section_Shared } from "./section_Shared";
import { section_Layout } from "./section_Layout";
import { section_Formatting } from "./section_Formatting";
import { section_Dialog } from "./section_Dialog";
import DialogClientListSelect from "@/components/dialogs/DialogClientListSelect";

export default {
  name: "SectionInfo",
  components: { ActionFabButton, DialogClientListSelect },

  setup(props, context) {
    let store = context.root.$store;

    const { selectedProject, createDialogInfoObject } = section_Shared(context);

    const showingDialog = ref(false);
    const obj = ref(null);

    const hasClient = computed(() => !!selectedProject.value.client);
    const lastName = computed(() => {
      if (hasClient) return store.getters.selectedClient.lastName;
      else return "-----";
    });
    const client = computed(() => {
      if (selectedProject.value.client) return selectedProject.value.client;
      else return {};
    });
    const clientName = computed(
      () => `${client.value.firstName}, ${client.value.lastName}`
    );

    const showDialog = () => {
      let toggle = (b) => (showingDialog.value = b);
      obj.value = createDialogInfoObject();
      obj.value.close = () => toggle(false);
      obj.value.select = (client2) => {
        store.dispatch("setClientToProject", client2);
        toggle(false);
      };
      toggle(true); // open the dialog
    };

    return {
      ...section_Shared(context),
      ...section_Layout(context),
      lastName,
      client,
      hasClient,
      clientName,
      obj,
      showingDialog,
      showDialog,
      selectedProject,
    };
  },
};
</script>

<style>
</style>